import { t } from "@redotech/redo-i18n";
import { Condition as ModelCondition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  orderCountGreaterThanFromModel,
  validateOrderCountGreaterThanCondition,
  type OrderCountGreaterThanState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const ORDER_COUNT_GREATER_THAN = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<OrderCountGreaterThanState>
  >,
): ConditionType<
  OrderCountGreaterThanState,
  ModelCondition.OrderCountGreaterThan
> => ({
  name: CONDITION_NAMES[ModelCondition.ORDER_COUNT_GREATER_THAN],
  description(state) {
    return t("More than {{count}} orders", { count: +state });
  },
  Details(props: ConditionTypeDetailsProps<OrderCountGreaterThanState>) {
    return React.createElement(Details, props);
  },
  empty: String(0),
  fromModel(model) {
    return orderCountGreaterThanFromModel(model);
  },
  toModel(state) {
    return { type: ModelCondition.ORDER_COUNT_GREATER_THAN, orderCount: state };
  },
  valid(state) {
    return validateOrderCountGreaterThanCondition(state).valid;
  },
});
